import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { MatTableModule } from '@angular/material/table';
import { AgrDialogModule } from '@next/core-lib/dialog';
import { LetDirective, PushPipe } from '@ngrx/component';

import { SoilAnalysisCompleteViewDialogComponent } from './soil-analysis-complete-view-dialog/soil-analysis-complete-view-dialog.component';
import { SoilAnalysisQuickViewComponent } from './soil-analysis-quick-view.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [SoilAnalysisQuickViewComponent, SoilAnalysisCompleteViewDialogComponent],
  imports: [
    CommonModule,
    SharedModule,
    LetDirective,
    PushPipe,
    MatIconModule,
    MatButtonModule,
    MatTableModule,
    AgrDialogModule,
  ],
  exports: [SoilAnalysisQuickViewComponent],
})
export class SoilAnalysisModule {}
